import { Grid, Paper } from "@material-ui/core";
import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { Waypoint } from "react-waypoint";
import ItemCard from "../../../components/Cards/ItemCard";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import NoContentText from "../../../components/NoContentText/NoContentText";
import NumberDisplayedText from "../../../components/NumberDisplayedText/NumberDisplayedText";
import * as Constants from "../../../data/StringConstants";
import { generateThumbnailUrl } from "../../../utils/thumbnailHelpers";
import ItemsToolbar from "./ItemsToolbar";

/**
 * This is the top level presentational wrapper for viewing items. 
 * ItemsContent contains a toolbar with interactions for a set of items as well as 
 * any items passed in rendered as a grid of material cards.
 */
export default function ItemsContent(props) {
	const { items, totalItemCount, copyItem, deleteItem, queryParams, history, fetchMore, isLoading } = props;
	const itemThumbnailWidth = 250;

	const renderItemCards = () => {
		return items.length ? (
			items.map((item, index) => (
				<Fragment key={index}>
					<ItemCard
						deleteItem={deleteItem}
						copyItem={copyItem}
						href={item.EditUrl}
						imageSource={generateThumbnailUrl(
							item.ThumbnailFileId,
							itemThumbnailWidth,
							undefined,
							item.Id
						)}
						item={item}
						key={item.Id}
					/>
					{index === items.length - 1 && renderWaypoint()}
				</Fragment>
			))
		) : (
				!isLoading && <NoContentText msg={Constants.NO_ITEMS_FOUND} />
			);
	};

	const renderWaypoint = () => {
		return <Waypoint onEnter={fetchMore} />
	}

	return (
		<Paper>
			<ItemsToolbar queryParams={queryParams} history={history}>
				<NumberDisplayedText totalCount={totalItemCount} type={"item"} />
			</ItemsToolbar>
			<Grid
				id="item-cards-container"
				container
				direction="row"
				justify="center"
			>
				{renderItemCards()}
				<Grid item xs={12}>
					{isLoading && <LoadingSpinner />}
				</Grid>
			</Grid>
		</Paper>
	);
}

ItemsContent.propTypes = {
	items: PropTypes.array,
	copyItem: PropTypes.func,
	deleteItem: PropTypes.func,
	queryParams: PropTypes.object,
	history: PropTypes.object,
	fetchMore: PropTypes.func,
	isLoading: PropTypes.bool
};
